import { Controller } from '@hotwired/stimulus';

// Emptying the panel, either from "Clear all" or from applying a saved search.
//
// It used to look for `[id="value-tag"]`, which nothing has ever produced: the
// chips are marked with `data-tag="value"`. So the hidden inputs went away -
// the search that ran was right - while the chips stayed on screen, and
// applying a saved search left you looking at the previous query plus the new
// one. Everything the panel can hold is cleared here, in one place.
export default class extends Controller {
    static targets = ['container'];

    connect() {
        this.boundClear = () => this.clearWithin(document)
        document.addEventListener('clear-filters', this.boundClear)
    }

    disconnect() {
        document.removeEventListener('clear-filters', this.boundClear)
    }

    removeAllFilters() {
        this.clearWithin(this.hasContainerTarget ? this.containerTarget : document)
    }

    clearWithin(scope) {
        // The submitted values.
        scope.querySelectorAll('[id="list-value"]').forEach(el => el.remove())

        // The chips, and whatever half-typed value sits in the field.
        scope.querySelectorAll('[data-tag="value"]').forEach(el => el.remove())
        scope.querySelectorAll('[data-multi-value-input-target="input"]').forEach(el => { el.value = '' })

        // The options that travel with a filter rather than as a value.
        scope.querySelectorAll('input[name$="[exact_match]"]').forEach(el => {
            if (!el.checked) return
            el.checked = false
            el.dispatchEvent(new Event('change', { bubbles: true }))
        })

        // Scalar selects (B2B / B2C / public) and funding range bounds.
        scope.querySelectorAll('.lf-scalar-filter').forEach(el => { el.value = '' })
        scope.querySelectorAll('.lf-range-bound').forEach(el => { el.value = '' })

        // Alpine-backed fields (the per-company cap, the excluded lists) listen
        // for this and reset themselves - their state lives in Alpine, not in
        // the DOM, so it cannot be cleared from here.
        document.dispatchEvent(new CustomEvent('filters-changed', { bubbles: true }))
        document.dispatchEvent(new CustomEvent('removed_filters', { bubbles: true }))
    }
}
